import React from 'react'
import Layout from '../components/Layout/Layout'
import MonadEventHighlight from '../components/Page/Homepage/EventHighlight'

const MonadEventHighlightTestPage = () => {
	return (
		<Layout>
			<section className={`p-4 md:px-12 md:pt-10`}>
				<h1 className={`text-3xl font-bold`}>Monad Event Highlight Test</h1>
				<p className={`mt-2 text-sm text-gray-600`}>
					This page renders the Monad event highlight component in isolation for development and visual checks.
				</p>
			</section>
			<MonadEventHighlight testMode />
		</Layout>
	)
}

export default MonadEventHighlightTestPage
